export default [
  {
    path: "/init",
    name: "init",
    component: () => import("../pages/init")
  },
  {
    path: "/mobile",
    name: "mobile",
    component: () => import("../pages/mobile")
  },
  {
    path: "/legal",
    component: () => import("../components/layouts/login-layout"),
    children: [
      {
        path: "privacy-policy",
        name: "privacy-policy",
        props: true,
        component: () => import("../pages/legal/privacy-policy")
      },
      {
        path: "terms-of-use",
        name: "terms-of-use",
        props: true,
        component: () => import("../pages/legal/terms-of-use")
      }
    ],
    meta: {
      auth: false,
      pageParams: false
    }
  },
  {
    path: "/auth",
    component: () => import("../components/layouts/login-layout"),
    children: [
      {
        path: "login",
        name: "login",
        component: () => import("../pages/auth/login")
      },
      {
        path: "login-app",
        name: "login-app",
        component: () => import("../pages/auth/login-app")
      },
      {
        path: "login-try-now",
        name: "login-try-now",
        component: () => import("../pages/auth/login-try-now")
      },
      {
        path: "login-email",
        name: "login-email",
        component: () => import("../pages/auth/login-email")
      }
      // {
      //   path: "login-video",
      //   name: "login-video",
      //   component: () => import("../pages/auth/login-video")
      // }
    ],
    meta: {
      auth: false,
      pageParams: false
    }
  },
  {
    path: "/login-video",
    name: "login-video",
    component: () => import("../pages/auth/login-video"),
    meta: {
      auth: false,
      pageParams: false
    }
  },
  {
    path: "/password",
    component: () => import("../components/layouts/passthrough"),
    children: [
      {
        path: "reset",
        name: "password-reset-request",
        component: () => import("../pages/password/reset-request")
      },
      {
        path: "confirmation",
        name: "password-reset-confirmation",
        component: () => import("../pages/password/reset-confirmation-code")
      },
      {
        path: "new",
        name: "password-reset-new",
        component: () => import("../pages/password/reset-password")
      }
    ],
    meta: {
      auth: false,
      pageParams: false
    }
  },
  {
    path: "/",
    component: () => import("../components/layouts/product-layout"),
    children: [
      {
        path: "",
        name: "overview",
        component: () => import("../pages/product/overview")
      },
      {
        path: "match",
        name: "match",
        component: () => import("../pages/product/match")
      },
      {
        path: "match-group",
        name: "match-group",
        component: () => import("../pages/product/match-group")
      },
      {
        path: "match-multiple",
        name: "match-multiple",
        component: () => import("../components/match/matcher-multiple")
      }
    ],
    meta: {
      auth: true,
      pageParams: true
    }
  },
  {
    path: "/",
    component: () => import("../components/layouts/match-layout"),
    children: [
      {
        path: "match-done",
        name: "match-done",
        component: () => import("../pages/product/match")
      },
      {
        path: "match-done-group",
        name: "match-done-group",
        component: () => import("../pages/product/match-group")
      },
      {
        path: "others",
        name: "others",
        component: () => import("../pages/product/others")
      }
    ],
    meta: {
      auth: true,
      pageParams: true
    }
  },
  {
    path: "/try-now",
    component: () => import("../components/layouts/try-now-layout"),
    children: [
      {
        path: "",
        name: "try-now",
        component: () => import("../pages/auth/login-try-now")
      }
    ],
    meta: {
      auth: false,
      pageParams: false
    }
  },
  {
    path: "/error/page-params",
    name: "error-page-params",
    component: () => import("../pages/error/page-params")
  },
  {
    path: "*",
    name: "404",
    component: () => import("../pages/error/404")
  }
];
